import { useState } from "react";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import PricingHero from "@/components/landing/preise/PricingHero";
import PricingToggle from "@/components/landing/preise/PricingToggle";
import PricingCards from "@/components/landing/preise/PricingCards";
import PricingTable from "@/components/landing/preise/PricingTable";
import PricingAddons from "@/components/landing/preise/PricingAddons";
import PricingFAQ from "@/components/landing/preise/PricingFAQ";
import CTASection from "@/components/landing/CTASection";
import CustomerLogosSection from "@/components/landing/CustomerLogosSection";
import { SEOHead } from "@/hooks/useSEO";
import { useLanguage } from "@/hooks/useLanguage";
import {
  StructuredDataHead,
  LLMMetadataHead,
  organizationSchema,
  softwareSchema,
  createWebPageSchema,
} from "@/hooks/useStructuredData";

const Preise = () => {
  const { language } = useLanguage();
  const [isYearly, setIsYearly] = useState(true);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="preise" locale={language} />
      <StructuredDataHead schemas={[
        organizationSchema,
        softwareSchema,
        createWebPageSchema(
          "Preise & Pakete – Transparente KI-Lösungen | Chathero",
          "Flexible Preismodelle für jede Unternehmensgröße. Starter, Professional und Enterprise Pakete. 14 Tage kostenlos testen.",
          "/preise",
          [
            { name: "Home", url: "/" },
            { name: "Preise", url: "/preise" },
          ]
        ),
        {
          "@context": "https://schema.org",
          "@type": "PriceSpecification",
          name: "Chathero Preise",
          priceCurrency: "EUR",
          price: "165",
          validFrom: "2024-01-01",
          eligibleQuantity: {
            "@type": "QuantitativeValue",
            value: 1,
            unitText: "Monat",
          },
        },
      ]} />
      <LLMMetadataHead
        title="Preise & Pakete – Transparente KI-Lösungen | Chathero"
        description="Flexible Preismodelle für jede Unternehmensgröße. Essential ab €165/Monat, Professional ab €440/Monat. 14 Tage kostenlos testen."
        keywords="Chathero Preise, AI Agent Kosten, AI Agent Preise, Enterprise Pricing, Chatbot Tarife, SaaS Preise"
        canonicalUrl="https://chathero.ai/preise"
        aiCategory="Pricing, SaaS Subscription"
        aiEntityType="Pricing Page"
        aiUseCase="AI Agent Preisvergleich, Chatbot Kosten, SaaS Tarife"
      />
      <Header />
      <main>
        <PricingHero />
        <section className="py-12 bg-background">
          <div className="container mx-auto px-4">
            <PricingToggle isYearly={isYearly} onToggle={setIsYearly} />
            <PricingCards isYearly={isYearly} />
            <PricingTable />
          </div>
        </section>
        <PricingAddons />
        <CustomerLogosSection />
        <PricingFAQ />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Preise;
